import { useSyncExternalStore } from "react";
import { darf, getMich, getToken, onAuthChange, onIchChange, type Ich } from "../api";

/** Ob gerade jemand angemeldet ist — als React-Zustand.
 *
 *  Über useSyncExternalStore statt useState/useEffect: der Token liegt in
 *  localStorage, also außerhalb von React. So sehen alle Komponenten
 *  denselben Wert im selben Rendervorgang, statt kurz auseinanderzulaufen. */
export function useAuthed(): boolean {
  return useSyncExternalStore(
    onAuthChange,
    () => getToken() !== null,
    () => false,
  );
}

/** Wer angemeldet ist — oder null. */
export function useIch(): Ich | null {
  return useSyncExternalStore(onIchChange, getMich, () => null);
}

/** Ob der angemeldete Benutzer eine Berechtigung hat. */
export function useDarf(perm: string | undefined): boolean {
  const ich = useIch();
  if (!perm) return true;
  // `ich` steht nur im Abhängigkeitsspiel, damit React neu rendert, wenn
  // sich die Anmeldung ändert; entschieden wird in darf().
  void ich;
  return darf(perm);
}
